import { initDB } from "react-indexed-db";

export const storeName = "_vjhi";
export const imageStoreName ="_hpjhi"

export const DBConfig = {
  name: "_hjhwa",
  version: 2,
  objectStoresMeta: [
    {
      store: storeName,
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "jhhid", keypath: "jhhid", options: { unique: false } },
        {
          name: "user_image_blob",
          keypath: "user_image_blob",
          options: { unique: false },
        },
        {
          name: "user_image_url",
          keypath: "user_image_url",
          options: { unique: false },
        },
      ],
    },
    {
      store: imageStoreName,
      storeConfig : {keyPath: "id",autoIncrement: true},
      storeSchema: [
        { name: "iid", keypath: "iid",options: {unique: false}},
        {
          name: "user_image_blob",
          keypath: "user_image_blob",
          options: { unique: false },
        },
        {
          name: "user_image_url",
          keypath: "user_image_url",
          options: { unique: false },
        }
    ]
    }

  ],
};
initDB(DBConfig);
